
import { useFetchDomainVisibilityAnalysisProcessQuery } from '../../service';
import { useEffect, useState } from 'react';


export default function useVisibilityAnalysisProgress(domain: string) {
    const [hasActiveProcess, setHasActiveProcess] = useState<boolean>(false);
    const [processGuid, setProcessGuid] = useState<string | null>(null);

    const { data: domainVisibilityAnalysisProcess, isLoading, error, isError } = useFetchDomainVisibilityAnalysisProcessQuery(
        { domain, processGuid },
        {
            pollingInterval: hasActiveProcess ? 10_000 : 0,
            refetchOnMountOrArgChange: true,
        }
    );
    const analysisError = domainVisibilityAnalysisProcess?.output?.error || null;

    useEffect(() => {
        // We didn't have an active process but now we do        
        if (domainVisibilityAnalysisProcess && hasActiveProcess === false) {
            setHasActiveProcess(true);
            setProcessGuid(domainVisibilityAnalysisProcess.guid);
        }

        // Active process completed
        if (domainVisibilityAnalysisProcess && domainVisibilityAnalysisProcess.status === 'completed' && hasActiveProcess === true) {
            setHasActiveProcess(false);
            setProcessGuid(null);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domainVisibilityAnalysisProcess]);

    return {
        analysisError: analysisError,
        isLoading,
        error,
        isError,
        hasActiveProcess
    };
}
